import api from './api';

const productService = {
    getProducts: async () => {
        const response = await api.get('/api/products/');
        return response.data;
    },

    createProduct: async (productData) => {
        const response = await api.post('/api/products/', productData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    updateProduct: async (id, productData) => {
        const response = await api.patch(`/api/products/${id}/`, productData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    deleteProduct: async (id) => {
        const response = await api.delete(`/api/products/${id}/`);
        return response.data;
    },

    getCategories: async () => {
        const response = await api.get('/api/categories/');
        return response.data;
    },

    createCategory: async (categoryData) => {
        const response = await api.post('/api/categories/', categoryData);
        return response.data;
    },

    searchProducts: async (query) => {
        const response = await api.get(`/api/products/?search=${encodeURIComponent(query)}`);
        return response.data;
    }
};

export default productService;
